// extracted by mini-css-extract-plugin
export default {"container":"PopUp_container__LWT0r","content":"PopUp_content__EkT0N","infobox":"PopUp_infobox__37naL","button":"PopUp_button__r7a4a"};